import React from 'react';
import './styles.css';

//import { VisibilityContext } from 'react-horizontal-scrolling-menu';

export function Card({
  selected,
  onClick,
  title,
}: {
  itemId: string;
  selected: boolean;
  onClick: Function;
  title: string;
}) {
  //const visibility = React.useContext(VisibilityContext);

  //const visible = visibility.isItemVisible(itemId);

  return (
    <div
      onClick={() => onClick()}
      role="button"
      style={{
        display: 'inline-block',
        // margin: '10px',
        // width: '160px',
        userSelect: 'none',
      }}
      tabIndex={0}
      className="card"
    >
      <div>
        {/* <div style={{ backgroundColor: visible ? 'transparent' : 'gray' }}>visible: {JSON.stringify(visible)}</div> */}
        {/* <div>selected: {JSON.stringify(!!selected)}</div> */}
        <div className={`menu-item${selected ? ' active' : ''}`} style={{ fontSize: '1rem' }}>
          {title.toLowerCase()}
        </div>
      </div>
    </div>
  );
}
